import { useTranslation } from "react-i18next";
import defaultContent from "../../../../../content/performanceIncomeDashboard";
import { useLayoutEffect, useRef, useState } from "react";
import { IconCarrot } from "../../../../../common/icons/IconCarrot/IconCarrot";
import "./SopCard.scss";

export interface SopCardMonthlyPv {
  month: string;
  value: string;
}
export interface SopCardProps {
  current: string;
  expected: string;
  monthlyPv: SopCardMonthlyPv[];
}

export const SopCard = ({ current, expected, monthlyPv }: SopCardProps) => {
  const { t } = useTranslation(["performanceIncomeDashboard"]);
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  const innerRef = useRef<HTMLDivElement | null>(null);
  const [collapsibleHeight, setCollapsibleHeight] = useState<string>("0px");

  useLayoutEffect(() => {
    const el = innerRef.current;
    if (!el) return;

    const next = isExpanded ? `${el.scrollHeight}px` : "0px";
    setCollapsibleHeight(next);
  }, [isExpanded, monthlyPv]);

  const handleButtonClick = () => {
    setIsExpanded((prev) => !prev);
  };

  const getLabel = (isExpanded: boolean) => {
    return isExpanded
      ? t(`performance.incomeTile.showLess`, defaultContent.performance.incomeTile.showLess).toString()
      : t(`performance.incomeTile.showMore`, defaultContent.performance.incomeTile.showMore).toString();
  };

  return (
    <div className="sopCard">
      <div className="headerSection">
        <div className="header">
          <p className="title">
            {t(`performance.incomeTile.currentSop`, defaultContent.performance.incomeTile.currentSop).toString()}
          </p>
          <h5 className="val">{current}</h5>
        </div>
        <div className="header right">
          <p className="title">
            {t(`performance.incomeTile.expectedSop`, defaultContent.performance.incomeTile.expectedSop).toString()}
          </p>
          <h5 className="val">{expected}</h5>
        </div>
      </div>

      {monthlyPv.length > 0 && (
        <div
          className={`monthlyPvCollapsible ${isExpanded ? "isExpanded" : "isCollapsed"}`}
          aria-hidden={!isExpanded}
          style={{ height: collapsibleHeight }}
        >
          <div ref={innerRef} className="monthlyPvInner">
            {monthlyPv.map((item) => (
              <div key={item.month}>
                <hr className="divider" />
                <div className="monthRow">
                  <p className="monthName">{item.month}</p>
                  <p className="monthValue">{item.value}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {monthlyPv.length > 0 && (
        <div className="buttonSection" style={{ marginTop: isExpanded ? "1rem" : "unset" }}>
          <button
            type="button"
            className="buttonTextContainer"
            onClick={handleButtonClick}
            aria-expanded={isExpanded}
            aria-label={getLabel(isExpanded)}
          >
            <p className="buttonText">{getLabel(isExpanded)}</p>
            {isExpanded ? (
              <IconCarrot orientation="up" color="blue" height={14} />
            ) : (
              <IconCarrot orientation="down" color="blue" height={14} />
            )}
          </button>
        </div>
      )}
    </div>
  );
};
